/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Классификатор
 */
export interface Classifier { 
    /**
     * Идентификатор
     */
    id?: number;
    /**
     * Тип
     */
    classType?: number;
    /**
     * Идентифиактор владельца
     */
    ownerID?: number;
    /**
     * Короткое имя
     */
    shortName?: string | null;
    /**
     * Владелец
     */
    owner?: string | null;
    /**
     * Идентифиактор изображения
     */
    pictureID?: number;
    /**
     * Заметки
     */
    notes?: string | null;
}

